import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const mobileNav = document.querySelector('[data-mobile-nav]')
const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]')
const mobileNavClose = document.querySelector('[data-mobile-nav-close')
const mobileNavPanels = Array.from(mobileNav.querySelectorAll('[data-panel]'))
const mobileNavPanelToggles = mobileNav.querySelectorAll('[data-target-panel]')
const mobileNavBack = mobileNav.querySelectorAll('[data-back]')
const mobileNavPanelsState = ['main']

/**
 *
 */
const openMobileNav = () => {
    document.body.dataset.mobileNavOpen = 'true'
    disableBodyScroll(mobileNav)
    document.addEventListener('keydown', handleEscape)
    document.addEventListener('click', handleClickOutside)
    mobileNavClose.focus()

    trapUserFocus()
}

/**
 *
 */
const closeMobileNav = () => {
    delete document.body.dataset.mobileNavOpen
    enableBodyScroll(mobileNav)
    document.removeEventListener('keydown', handleEscape)
    document.removeEventListener('click', handleClickOutside)
}

const handleEscape = (event) => {
    if (event.key === 'Escape') closeMobileNav()
}

const handleClickOutside = (event) => {
    if (!event.target.closest('[data-mobile-nav]') && !event.target.closest('[data-mobile-nav-toggle]')) closeMobileNav()
}

const updateNavState = () => {
    const [targetPanel] = [...mobileNavPanelsState].reverse()
    mobileNavPanels.forEach(panel => delete panel.dataset.active)
    mobileNav.querySelector(`[data-panel="${targetPanel}"]`).dataset.active = 'true'

    // Wait for css animation to finish before trapping focus
    setTimeout(() => {
        mobileNav.querySelector(`[data-panel="${targetPanel}"] .mobileNav__back`) ? mobileNav.querySelector(`[data-panel="${targetPanel}"] .mobileNav__back`).focus() : mobileNav.querySelector(`[data-panel="${targetPanel}"] .close-mobile-nav`).focus()
    }, 500)

    if (targetPanel === 'main') {
        // Update the first level nav button aria expanded value
        const mobileNavLinks = mobileNav.querySelectorAll(`[data-panel="${targetPanel}"] .mobileNav__mainLink`)
        mobileNavLinks.forEach((mobileNavLink) => {
            mobileNavLink.setAttribute('aria-expanded', false)
        })
    }

    trapUserFocus()
}

function trapUserFocus () {
    const activeNavPanel = document.querySelector('.mobileNav__panel[data-active]')

    activeNavPanel.addEventListener('keydown', function (e) {
        const focusableElements = activeNavPanel.querySelectorAll(
            'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )

        const firstFocusableElement = activeNavPanel.querySelector('.mobileNav__back') === null ? activeNavPanel.querySelector('.close-mobile-nav') : activeNavPanel.querySelector('.mobileNav__back')
        const lastFocusableElement = focusableElements[focusableElements.length - 1]

        if (e.target === firstFocusableElement && e.key === 'Tab' && e.shiftKey) {
            e.preventDefault()
            lastFocusableElement.focus()
        } else if (e.target === lastFocusableElement && e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault()
            firstFocusableElement.focus()
        }
    })
}

mobileNavToggle.addEventListener('click', () => {
    if (document.body.dataset.mobileNavOpen) closeMobileNav()
    else openMobileNav()
})

mobileNavClose.addEventListener('click', () => {
    closeMobileNav()
})

mobileNavPanelToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'true')
        mobileNavPanelsState.push(toggle.dataset.targetPanel)
        updateNavState()
    })
})

mobileNavBack.forEach((backButton) => {
    backButton.addEventListener('click', () => {
        mobileNavPanelsState.pop()
        backButton.setAttribute('aria-expanded', 'false')
        updateNavState()
    })
})
